/* eslint-disable */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import { FormattedMessage, injectIntl } from 'react-intl'
import styled from 'styled-components'
import { getPlaceHolderNumberplate } from 'core/utils/cultures/car'

import useGetCars from 'core/hooks/useGetCars'
import { Row, Col, Input, ButtonPrimary, ButtonLink, Form, notification } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { greys, font, fontFamily } from 'assets/themes/theme-default'
import { tradeInShape } from '../../shapes'
import configurationShape from '../../../configuration/shapes'

const InputRowWrapper = styled(Row)`
  &&& {
    padding: ${isMobile ? '0px' : '30px 0'};
    height: ${isMobile ? '45px' : '100px'};
    ${isMobile && 'margin-bottom: 30px;'}
  }
  .ant-form-explain {
    color: ${greys.dark2};
  }
`

const RegistrationInput = styled(Input)`
  &&& {
    text-align: center;
    padding: ${isMobile ? '4px 0 4px 0' : '15px'};
    height: ${isMobile ? '45px' : '60px'};
    border-radius: 0;
    font-size: ${font.size.lgxxl};
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.medium.name},`}
      ${fontFamily.medium};
    color: ${greys.dark2};
    border-color: ${greys.dark4};
    text-transform: uppercase;
    &::placeholder {
      font-size: ${font.size.lgxl};
      font-weight: ${font.weight.base};
      text-transform: none;
    }
  }
`
const RegistrationInputBorder = styled(Col)`
  background-color: ${greys.dark2};
  height: ${isMobile ? '45px' : '60px'};
  text-align: center;
  &:first-child {
    border-radius: 4px 0 0 4px;
  }
  &:last-child {
    border-radius: 0 4px 4px 0;
  }
`
const CardIcon = styled(SVG)`
  height: 70%;
  fill: ${greys.light4};
  vertical-align: middle;
  margin: 5px;
`
const CardIconEuropeanUnion = styled(SVG)`
  height: 100%;
  max-width: 75%;
  fill: ${greys.light4};
  vertical-align: middle;
`

const InputRow = styled(Row)`
  color: ${greys.dark1};
  font-size: ${font.size.sm};
  line-height: normal;
  svg {
    fill: ${greys.dark1};
  }
`

const RegistrationSearch = props => {
  const {
    intl,
    tradeIn,
    setTradeIn,
    showModal,
    form,
    form: { getFieldDecorator },
    deactivatedMakes,
    configuration
  } = props

  const [isValidMake, setIsValidMake] = useState(true)

  const { error, errorMessage, loading, getCarsByNumberplate, cars } = useGetCars({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' }),
    maximumAgeTradeInCars: configuration.automaticValidationSetting.maximumAgeTradeInCars
  })

  const { providerConfiguration } = configuration
  const { providerNumberplateId } = providerConfiguration

  const handleClickShowModal = async () => {
    let isInvalidForm = true
    let params = null
    await form.validateFields((err, values) => {
      if (!err) {
        isInvalidForm = false
        if (providerNumberplateId) {
          params = {
            numberplate: values.search,
            isVin: false
          }
        }
      }
    })

    if (isInvalidForm) return

    getCarsByNumberplate(params)
  }

  useEffect(() => {
    const runIt = vehiclesList => {
      const { filtersList, vehicle } = tradeIn

      const extendedFiltersList = {
        ...filtersList,
        vehiclesList
      }
      const newValues = form.getFieldsValue()

      if (deactivatedMakes.map(x => x.make).includes(vehiclesList[0].make)) {
        setIsValidMake(false)
      } else {
        const newVehicle = { ...vehicle, ...newValues }
        setTradeIn({
          ...tradeIn,
          filtersList: extendedFiltersList,
          vehicle: newVehicle
        })

        showModal()
      }
    }
    if (cars.length > 0) runIt(cars)
  }, [cars])

  useEffect(() => {
    if (!isValidMake) {
      notification.error({
        message: intl.formatMessage({ id: 'tradeIn-vehicle-confirm-inactive-make-subtitle-1' })
      })
    }
  }, [isValidMake])
  //  <CardIconF svg={svg.f} />

  let placeholder
  let rules = []
  if (providerNumberplateId) {
    placeholder = getPlaceHolderNumberplate()
    rules = [
      {
        pattern:
          '^((?![IOUiou])[A-Za-z]{2}-?[0-9]{3}-?(?![IOUiou])[A-Za-z]{2})?([0-9]{4}-?(?![IOUiou])[A-Za-z]{2}-?[0-9]{2})?([0-9]{3}-?(?![IOUiou])[A-Za-z]{3}-?[0-9]{2})?((?![IOUiou])[A-Za-z]{3}-?[0-9]{2}-?(?![IOUiou])[A-Za-z]{1})?((?![IOUiou])[A-Za-z]{2}-?[0-9]{5})?([A-Za-z]{3}-?(?![IOUiou])[0-9]{3})?$',
        message: `Ex : ${getPlaceHolderNumberplate()}`
      }
    ]
  }

  return (
    <>
      <Form>
        <InputRowWrapper type="flex" justify="center">
          <RegistrationInputBorder className="registration-left-border" span={3}>
            <CardIconEuropeanUnion svg={svg.europeanUnion} />
          </RegistrationInputBorder>
          <Col span={18}>
            <Form.Item>
              {getFieldDecorator('search', {
                rules: rules
              })(<RegistrationInput placeholder={placeholder} />)}
            </Form.Item>
          </Col>
          <RegistrationInputBorder className="registration-right-border" span={3} />
        </InputRowWrapper>

        <InputRow type="flex" justify="center">
          <Col span={24} style={{ textAlign: 'center' }}>
            {error && (
              <Row
                type="flex"
                align="middle"
                justify="center"
                gutter={isMobile ? 10 : 50}
                style={{ fontSize: font.size.base }}
              >
                <Col span={isMobile ? 4 : 4}>
                  <CardIcon svg={svg.warning} />
                </Col>
                <Col span={isMobile ? 18 : 18} style={{ textAlign: 'left' }}>
                  {errorMessage ? (
                    <FormattedMessage id={errorMessage} />
                  ) : (
                    <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card1-error" />
                  )}
                </Col>
              </Row>
            )}
          </Col>
          <Col style={{ textAlign: 'center', marginTop: '12px' }}>
            <ButtonPrimary onClick={handleClickShowModal} loading={loading}>
              <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card1-button" />
            </ButtonPrimary>
          </Col>
        </InputRow>
      </Form>
    </>
  )
}

RegistrationSearch.propTypes = {
  intl: PropTypes.shape().isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  showModal: PropTypes.func.isRequired,
  form: PropTypes.shape().isRequired,
  deactivatedMakes: PropTypes.arrayOf(PropTypes.number),
  configuration: configurationShape.isRequired
}

export default Form.create({ name: 'registrationSearchForm' })(injectIntl(RegistrationSearch))
